import { useMutation } from 'react-query'
import putRegisterEconomic from '../services/putRegisterEconomic'

function usePutRegisterEconomic() {

  return useMutation((value:object)=>putRegisterEconomic(value) );
}

export default usePutRegisterEconomic
